import { __rest } from 'tslib';
import React from 'react';
import { useColor } from '../../theme/Theme.js';
import { extractMarginProps, extractDimensionsProps } from '../../styling/utils.js';
import { Root } from './styled.js';

const levels = {
    h1: 'h1',
    h2: 'h2',
    h3: 'h3',
    h4: 'h4',
    h5: 'h5',
    h6: 'h6',
    d1: 'h1',
    d2: 'h2',
};
const Title = React.forwardRef((_a, ref) => {
    var { level = 'h1', uppercase, color, textAlign } = _a, props = __rest(_a, ["level", "uppercase", "color", "textAlign"]);
    const _color = useColor(color);
    const _b = extractMarginProps(props), { rest: withoutMargins } = _b, margins = __rest(_b, ["rest"]);
    const _c = extractDimensionsProps(withoutMargins), { rest } = _c, dimensions = __rest(_c, ["rest"]);
    return (React.createElement(Root, Object.assign({ "data-testid": 'tend-ui-title' }, rest, margins, dimensions, { ref: ref, "$level": level, "$uppercase": uppercase, "$color": _color, "$textAlign": textAlign, component: levels[level] })));
});
Title.displayName = 'Title';

export { Title };
//# sourceMappingURL=Title.js.map
